// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__7jUXB","time":"Timer_time__rAxcT"};